import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import IssuesData from './data.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import firebase from 'firebase'
import VueRouter from 'vue-router';
import { INIT_USER } from './store/types';
import Vuetify from 'vuetify'
import AxiosPlugin from './plugins/axios';
import store from './store';
import { routes } from './routes';
import 'vuetify/dist/vuetify.min.css'

Vue.use(BootstrapVue);
Vue.use(IssuesData);
Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(AxiosPlugin);

Vue.config.productionTip = false

// Configure router
const router = new VueRouter({
    mode: 'history',
    routes
});
var config = {

};

const unsubscribe = firebase.initializeApp({
    apiKey: "AIzaSyBTYgOBaabhFH5lCsVhbM_ZbzRjY0trYu4",
    authDomain: "hard2say-292df.firebaseapp.com",
    databaseURL: "https://hard2say-292df.firebaseio.com",
    projectId: "hard2say-292df",
    storageBucket: "hard2say-292df.appspot.com",
    messagingSenderId: "182325762813"
}).auth().onAuthStateChanged(user => {
    if (user) store.dispatch(INIT_USER, user.uid);
    else store.dispatch(INIT_USER, null);

    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(App)
    });

    unsubscribe();
});
